module.exports = __webpack_public_path__ + "static/media/pay-with-ada.b3bbfcc7.svg";